export const MockUserJourneyStates = [
    {
        step: 1,
        stepTitle: 'Start Tour',
        progress: 0
    },
    {
        step: 2,
        stepTitle: 'Welcome to Kavida',
        progress: 5
    },
    {
        step: 3,
        stepTitle: 'Welcome to Control Tower',
        progress: 10
    },
    {
        step: 4,
        stepTitle: 'Pending Approval',
        progress: 15
    },
    {
        step: 5,
        stepTitle: 'Filter By Ex-Mill Date',
        progress: 17
    },
    {
        step: 6,
        stepTitle: 'Check Notifications',
        progress: 20
    },
    {
        step: 7,
        stepTitle: 'Clicked on Notifications',
        progress: 25
    },
    {
        step: 8,
        stepTitle: 'Order Manager Introduction',
        progress: 30
    },
    {
        step: 9,
        stepTitle: 'View Risks',
        progress: 35
    },
    {
        step: 10,
        stepTitle: 'Order Timeline',
        progress: 40
    },
    {
        step: 11,
        stepTitle: 'Check milestones',
        progress: 45
    },
    {
        step: 12,
        stepTitle: 'Speak to your supplier',
        progress: 50
    },
    {
        step: 13,
        stepTitle: 'Compose an Email',
        progress: 55
    },
    {
        step: 14,
        stepTitle: 'Send Email',
        progress: 60
    },
    {
        step: 15,
        stepTitle: 'Get Vessel Number',
        progress: 65
    },
    {
        step: 16,
        stepTitle: 'Select Action',
        progress: 70
    },
    {
        step: 17,
        stepTitle: 'Enter Tracking Details',
        progress: 75
    },
    {
        step: 18,
        stepTitle: 'Submit Tracking Details',
        progress: 80
    },
    {
        step: 19,
        stepTitle: 'Global Risks',
        progress: 80
    },
    {
        step: 20,
        stepTitle: 'Global Risks Introduction',
        progress: 80
    },
    {
        step: 21,
        stepTitle: 'Check Global Risk News',
        progress: 85
    },
    {
        step: 22,
        stepTitle: 'Keep Track of Risks',
        progress: 85
    },
    {
        step: 23,
        stepTitle: 'Check on Suppliers',
        progress: 90
    },
    {
        step: 24,
        stepTitle: 'See Updates from Port',
        progress: 95
    },
    {
        step: 25,
        stepTitle: 'Start Free Trial',
        progress: 100
    }
]
